/**
 * Dados de usuários que serão usado para
 * montar os demais dados da simulação.
 *
 * A chave do objeto deve ser o ID do usuário
 */
export default {
    '2': {
        id: 2,
        name: 'João',
        email: 'joao.doe@mail.com',
        surname: 'Doe',
        role: 'Mestre de Obras',
        image: null,
        phone: '(51) 9999-9999',
        country_code: null,
        address: null,
    },
    '719': {
        id: 719,
        name: 'Bernardo',
        email: 'bernardo@gmail.com',
        surname: 'Maia',
        role: 'Estagiário',
        image: null,
        phone: '',
        country_code: null,
        address: 'teste',
    },
    '1': {
        id: 1,
        name: 'Leonardo',
        email: 'leonardo@gmail.com',
        surname: 'Feller',
        role: 'Estagiário',
        image: null,
        phone: '-',
        country_code: null,
        address: 'Rua Pedro dos Santos, 99',
    },
    '155': {
        id: 155,
        name: 'Mário',
        email: 'mario.barbosa@mail.com',
        surname: 'Barbosa',
        role: 'GP',
        image: null,
        phone: '-',
        country_code: null,
        address: null,
    },
    '58': {
        id: 58,
        name: 'Lucas',
        email: 'lucas.sergio@mail.com',
        surname: 'Sérgio',
        role: 'Social Media',
        image: null,
        phone: null,
        country_code: null,
        address: null,
    },
    '131': {
        id: 131,
        name: 'Matheus',
        email: 'mdhenrique@gmail.com',
        surname: 'Henrique',
        role: 'SM ',
        image: null,
        phone: '(',
        country_code: null,
        address: null,
    },
}
